export default __webpack_public_path__ + "static/akshaya-6c5b070113eddf54ada898f73dff5074.jpg";